import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
var selectStyle = {
    background: 'transparent',
    border: '1px solid #ddd',
    paddingLeft: '75px',
    height: '25px'
};
var labelStyle = {
    color: 'black',
    marginRight: '-75px'
};
var TaskPercentage = /** @class */ (function (_super) {
    tslib_1.__extends(TaskPercentage, _super);
    function TaskPercentage(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePercentageChange = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.props.task.setPercentage(Number(e.target.value));
                        return [4 /*yield*/, this.props.task.updatePercentage()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    TaskPercentage.prototype.render = function () {
        var task = this.props.task;
        var values = Array.from({ length: 100 })
            .map(function (_, i) { return i + 1; })
            .filter(function (i) { return i % 5 === 0; });
        var options = [0].concat(values).map(function (i) { return (React.createElement("option", { key: i, value: i },
            i,
            " %")); });
        return (React.createElement("div", null,
            React.createElement("small", { style: labelStyle }, "K\u00E9sz\u00FClts\u00E9g:"),
            React.createElement("select", { disabled: task.isReadonly, style: selectStyle, value: task.percentage, onChange: this.handlePercentageChange, children: options })));
    };
    TaskPercentage = tslib_1.__decorate([
        observer
    ], TaskPercentage);
    return TaskPercentage;
}(React.Component));
export default TaskPercentage;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskPercentage.tsx
// module id = 750
// module chunks = 0